import React from 'react';

import {
    SelectAsyncInput,
    SelectAsyncInputProps,
} from 'src/shared/components/form-elements/select-input';
import FormContext from 'src/shared/contexts/form-context';

// Here the type for the SelectAsyncInputProps should be Options but I don't know where Options come from so I used any
type FormSelectAsyncProps = SelectAsyncInputProps<any> & { id: string };

export const FormSelectAsync = ({ id, ...props }: FormSelectAsyncProps) => {
    const formMethods = React.useContext(FormContext);
    return (
        <SelectAsyncInput
            onChange={(option: any) => {
                formMethods.handleChange && formMethods.handleChange(option.value, id);
            }}
            id={id}
            errorMessage={formMethods.errors[id]?.message}
            {...props}
        />
    );
};
